<template>
    <div>
        <Title :title="'课程管理'" :noBorder="true"></Title>
        <Menu mode="horizontal" :theme="'light'" :active-name="active" class="tabs" @on-select="menuChange">
            <MenuItem name="allCourse">
                全部课程
            </MenuItem>
            <!-- <MenuItem name="allocated">
                已分配课程
            </MenuItem>
            <MenuItem name="toBeAllocated">
                待分配课程
            </MenuItem> -->
            <MenuItem name="dataSet">
                数据集管理
            </MenuItem>
            <MenuItem name="images">
                镜像管理
            </MenuItem>
        </Menu>
        <div>
            <component :is="currentPage" ></component>
        </div>
    </div>
</template>

<script>
    import Title from "../../ability/components/title";
    import allCourse from "./courseManag/allCourse";
    import allocated from "./courseManag/allocated";
    import toBeAllocated from "./courseManag/toBeAllocated";
    import dataSet from "./courseManag/dataSet/dataSetList";
    import images from "./courseManag/images/imagesList";
    import {mapActions, mapState} from 'vuex'
    export default {
        name: "courseManag",
        components: {
            Title,
            allCourse,
            allocated,
            toBeAllocated,
            dataSet,
            images
        },
        data(){
            return{
                active:'allCourse',
                currentPage:'allCourse'
            }
        },
        methods: {
            ...mapActions({
                getDirection: 'courseManage/getDirection',
            }),
            menuChange(name){
                this.currentPage = name
            }
        },
        mounted () {
            this.getDirection()
            // 锚点
            let current = this.$route.params.current;
            if(current == undefined){
                this.active = 'allCourse';
                this.currentPage = 'allCourse';
            }else{
                this.active = current;
                this.currentPage = current;
            }
        },
    }
</script>

<style scoped lang="less">
    @import "../style/index";
</style>
